<div class="badge" [ngClass]="badgeClasses" [ngStyle]="badgeStyles">
    <div class="arrow" [ngClass]="arrowClasses" *ngIf="arrow"></div>
    <ng-content></ng-content>
</div>
